<mat-grid-list [cols]="columnas" rowHeight="100vh" (window:resize)="onResize($event)" style="overflow-x: hidden;">
    <mat-grid-tile [colspan]="colspanImg" class="columna" *ngIf="!columnaOculta">
        <img src="./assets/images/Logo-IC-transparente.png" alt="Logo IC" class="img">
    </mat-grid-tile>
    <mat-grid-tile [colspan]="colspanError" class="columnaDos">
        <div class="mensaje-zone text-left">
            <h1 class="txt-error">Error <b>{{data.numberError}}</b></h1>
            <p class="p-error">{{data.longText}}</p>
        </div>
    </mat-grid-tile>
</mat-grid-list>

<div class="divLogo" *ngIf="columnaOculta">
    <img src="./assets/images/Logo-IC.png" alt="Logo IC" class="logo">
</div>